export class User {
    // private emailId: string;
    // private gender: string;
    // private fullName: string;
    // private phoneNumber: number;
    // private permanentPinCode: number;
    // private currentPinCode: number;
    // private qualification: number;
    // private graduationYear: string;
    // private referralName: number;
    // private referralContactNumber: number;

     rowNumber: string;
     fullName: string;
     phoneNumber: string;
     emailId: string;
     gender: string;
     permanentPinCode: number;
     currentPinCode: number;
     qualification: number;
     graduationYear: string;
     registeredDate: any;
     referralName: number;
     referralContactNumber: number;
     status: string;
     campaignShortName: string;
     currentYear: string;
     collegeState: string;
     discipline: string;
     collegeCity: string;
     percentage: number;

    // constructor($emailId: string, $gender: string, $fullName: string,
    //     $phoneNumber: number, $permanentPinCode: number,
    //     $currentPinCode: number, $qualification: number, $graduationYear: string, $referralName: number, $referralContactNumber: number) {
    //     this.emailId = $emailId;
    //     this.gender = $gender;
    //     this.fullName = $fullName;
    //     this.phoneNumber = $phoneNumber;
    //     this.permanentPinCode = $permanentPinCode;
    //     this.currentPinCode = $currentPinCode;
    //     this.qualification = $qualification;
    //     this.graduationYear = $graduationYear;
    //     this.referralName = $referralName;
    //     this.referralContactNumber = $referralContactNumber;
    // }

}
